import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import {
  NgbDateAdapter,
  NgbDateParserFormatter,
  NgbModule,
  NgbTimeAdapter
} from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from 'src/app/modules/shared-module/shared.module';
import { CustomAdapter } from './adapters/custom-date-adapter';
import { CustomDateParserFormatter } from './adapters/custom-date-parser-formatter';
import { NgbTimeStringAdapter } from './adapters/custom-time-adapter';
import { TimePickerComponent } from './time-picker.component';

@NgModule({
  imports: [BrowserModule, FormsModule, NgbModule, FontAwesomeModule, SharedModule],
  declarations: [TimePickerComponent],
  exports: [TimePickerComponent],
  bootstrap: [TimePickerComponent],
  providers: [
    { provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter },
    { provide: NgbDateAdapter, useClass: CustomAdapter },
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
  ],
})
export class TimePickerModule {}
